<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">评价</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <div style="padding: 20px;">

          <el-input v-model="text" type="textarea" placeholder="评价内容"></el-input>


        </div>




      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="edit">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Photo',
  components: {},
  props: [],
  data() {
    return {

      loading: false,

      activityOrderCode:'',

      text:'',

    }
  },
  methods: {

    init(row){
      this.activityOrderCode = row.activityOrderCode;
      this.text = row.evaluate;
    },

    closeSelf() {
      this.$emit("closeEvaluate");
    },


    edit(){

      if(this.text == ''){
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/Evaluate',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderCode:this.activityOrderCode,
          msg:this.text,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){

          this.$emit("closeEvaluate");
          this.$emit("getList");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>
